( function( app ) {
  const COMPONENT = {
    init: function() {
      const components = document.querySelectorAll( '[data-component="multi-cta"]' );

      components.forEach( ( component ) => {
        const truck = component.querySelector( '.multi-cta__truck-graphic' );
        if ( !truck ) return;

        const observer = new IntersectionObserver(
            ( entries ) => {
              entries.forEach( ( entry ) => {
                if ( entry.isIntersecting ) {
                  truck.classList.add( 'is-active' );
                  observer.unobserve( component );
                }
              } );
            },
            {threshold: 0.2},
        );

        observer.observe( component );
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'multi-cta', COMPONENT );
} )( app );
